import React, { useEffect } from "react";
import { monetateDetailsAction } from "../../middleware/monetateDetailsAction";
import { useDispatch } from "react-redux";

function ZeroResultContainer(props) {

  const dispatch = useDispatch();
  // useEffect(()=>{
  //   if(props.containerObject && props.containerObject.zeroResultContent && document.getElementById('cb-footer-cwv')) {
  //     if(document.getElementById('cb-footer-cwv').classList.contains("d-none")) {
  //       console.log("resize event d-none removed");
  //       document.getElementById('cb-footer-cwv').classList.remove("d-none");
  //        document.getElementById('cb-footer-cwv').classList.add("d-block");
  //       }
  //   }
  // },[props.containerObject])
  useEffect(()=>{
    if(props.containerObject.zeroResultContent){
      dispatch(monetateDetailsAction({addSearch : [ "addSearch", {"searchTerm": props.containerObject?.navigationState, "searchType": "site"}], setPageType : ["setPageType", "nosearch"] }))     
     // dispatch(monetateDetailsAction({setPageType : ["setPageType", "nosearch"]}))		

      // window.monetateQ = window.monetateQ || [];
      // window.monetateQ.push(["setPageType", "nosearch"]);
      // window.monetateQ.push(["trackData"]);
    }

  },[props.containerObject])
  
  return (
    <div data-cont-id={props.containerObject.contentId} data-zone={props.dataZone} data-page-id={props.contentId} data-template-name={props.templateName} className={`vast-plugin-content row g-0`} style={{overflowX:"hidden"}}>
      {props.containerObject && props.containerObject.zeroResultContent ?
          <div className="row g-0 zeroResultContainer px-3 mb-3" >
          {props.containerObject.zeroResultsTitle ?
            <div className="row g-0  ">
              {/* {props.containerObject.zeroResultContent.secondaryHeadingContent} */}
              <span dangerouslySetInnerHTML={{ __html: props.containerObject.zeroResultsTitle }}></span>
            </div> : ""}
          {props.containerObject.zeroResultContent ?
            <div className="row g-0 ">
              {props.containerObject && props.containerObject.zeroResultsHtmlRawContent ? <div dangerouslySetInnerHTML={{ __html: props.containerObject.zeroResultsHtmlRawContent }}></div> :
                <div className="">
                  <div className="message message-yellow p-0">We were unable to find any products or resources that matched your search term.</div>
                  <h4>Here are some suggestions to help you find what you're looking for:</h4>
                  <ul>
                    <li>As you type in the search box, see if one of the options that is automtically presented meets your needs. If so, simply click on that option.</li>
                    <li>Remove punctuation, such as dashes, from your search term.</li>
                    <li>Remove prefixes that may appear in some of our catalogs. Prefixes are usually two letters, and they usually precede an item number.</li>
                    <li>Still having trouble? <span dangerouslySetInnerHTML={{ __html: `<a class="c-cust-link" onclick="javascript:showChat();" style="cursor:pointer">Click to Chat with Customer Service</a>` }}></span> or call us at 800.334.5551 from 7:30am to 8pm ET Monday-Friday.</li>
                  </ul>
                </div>}
                
            </div> : ""}</div>
             : ""}
    </div>
  );
}

export default ZeroResultContainer;
